// note: general import
import { Navigate, useLocation } from "react-router-dom";
import { cookies } from "utils/cookies";
import { selectRegisterStep } from "state/reducer/auth";
import { useSelector } from "react-redux";
import { createTokenService, hasValidAccessToken } from "config/TokenService";
import React from "react";

// note: cannot get key after set recently via cookie, It's return undefined, It's not same use localstorage.
export function PreventDirectAccess({ children }) {
  const [authState, setAuthState] = React.useState("checking");
  const location = useLocation();

  const tokenService = createTokenService({
    baseURL: process.env.REACT_APP_TENANT_BE,
    // onLogout: (err) => onLogoutHandler?.(err),
  });

  React.useEffect(() => {
    let mounted = true;

    (async () => {
      // note: fast path: already-valid access token (no flicker)
      if (hasValidAccessToken()) {
        if (mounted) setAuthState("authed");
        return;
      }

      let newToken = null;

      try {
        // note: try one silent refresh
        newToken = await tokenService.getValidToken();
      } catch (error) {
        console.error("ERROR (silent refresh):", error);
      }

      if (!mounted) return;

      if (newToken) {
        setAuthState("authed");
      } else {
        setAuthState("guest");
      }
    })();

    return () => {
      mounted = false;
    };
  }, []); // note: only run once on mount

  // note: while deciding, render nothing (or a spinner if you want)
  if (authState === "checking") return null;

  // note: (IMPORTANT: render-driven redirect — no setTimeout, no side-effects in render)
  if (authState === "guest") {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // note: authenticated
  return children;
}

export function DirectAccess({ children }) {
  if (
    cookies.get("token")?.token ||
    cookies.get("refreshToken")?.refreshToken
  ) {
    return <Navigate to={"/"} replace={true} />;
  }

  return children;
}

export function DirectAccessByRegister({ children }) {
  const registerStep = useSelector(selectRegisterStep);

  if (cookies.get("token")?.token && registerStep?.isComplated) {
    return <Navigate to={"/"} replace={true} />;
  }
  return children;
}
